/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramGeoControllerGetRegionsWithoutCountryIdQueryResponse } from '../types/TelegramGeoControllerGetRegionsWithoutCountryId.ts';

function getTelegramGeoGetRegionsWithoutCountryIdUrl() {
  const res = { method: 'GET', url: `/api/telegram/geo/regions` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/regions}
 */
export async function telegramGeoGetRegionsWithoutCountryId(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramGeoControllerGetRegionsWithoutCountryIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getTelegramGeoGetRegionsWithoutCountryIdUrl().url.toString(), ...requestConfig });
  return res.data;
}
